import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translator',
  pure: false,
})
export class TranslatorPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(object: any, key?: string) {
    const currentLang =
      this.translate.currentLang || this.translate.store?.currentLang || this.translate.getDefaultLang?.();
    const lang = currentLang === 'en' ? 'En' : 'Sk';
    if (object && object.nameSk) {
      return object[(key || 'name') + lang];
    } else return '';
  }
}
